import { DESIGN_PREVIEW } from './designPreview';

export type StartupIssue = {
  key: string;
  message: string;
};

type EnvBag = {
  DEV?: boolean;
  VITE_TMDB_API_KEY?: string;
  VITE_SUPABASE_URL?: string;
  VITE_SUPABASE_ANON_KEY?: string;
  VITE_API_BASE_URL?: string;
  VITE_NATIVE_BUILD?: string;
};

function present(value: string | undefined): boolean {
  return typeof value === 'string' && value.trim().length > 0;
}

/**
 * Collect missing client config without throwing.
 * Module-level throws blank the Capacitor WebView before ErrorBoundary exists.
 */
export function collectStartupIssues(env: EnvBag = import.meta.env): StartupIssue[] {
  if (DESIGN_PREVIEW) return [];

  const issues: StartupIssue[] = [];

  if (!present(env.VITE_TMDB_API_KEY)) {
    issues.push({
      key: 'VITE_TMDB_API_KEY',
      message: 'Movie artwork key is missing from this build.',
    });
  }
  if (!present(env.VITE_SUPABASE_URL)) {
    issues.push({
      key: 'VITE_SUPABASE_URL',
      message: 'Account service URL is missing from this build.',
    });
  }
  if (!present(env.VITE_SUPABASE_ANON_KEY)) {
    issues.push({
      key: 'VITE_SUPABASE_ANON_KEY',
      message: 'Account service key is missing from this build.',
    });
  }

  const apiBase = (env.VITE_API_BASE_URL || '').replace(/\/$/, '');
  if (env.VITE_NATIVE_BUILD === '1' && !apiBase.startsWith('https://')) {
    issues.push({
      key: 'VITE_API_BASE_URL',
      message: 'Native builds need an HTTPS MovieMe API origin (https://www.moviemeapp.com).',
    });
  }

  return issues;
}

export const STARTUP_ISSUES = collectStartupIssues();
export const STARTUP_CONFIG_OK = STARTUP_ISSUES.length === 0;
